export default __webpack_public_path__ + "img/fgKDHLjo.829b6af3.svg";